interface ServiceButtonProps {
  title: string
  onClick?: () => void
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  variant?: 'default' | 'white' | 'orange'
}

import arrowRight from '../../assets/images/arrow-right.svg'
import arrowRightWhite from '../../assets/images/arrow-right-white.svg'

function ServiceButton({ 
  title, 
  onClick, 
  className = '',
  disabled = false,
  type = 'button',
  variant = 'default'
}: ServiceButtonProps) {
  const baseClasses = "font-bold transition-all duration-300 flex items-center rounded-full px-6 pl-10 py-2"
  const disabledClasses = disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
  
  let variantClasses = ""
  if (variant === 'white') {
    variantClasses = "bg-white text-[#191919] hover:bg-gray-100"
  } else if (variant === 'orange') {
    variantClasses = "bg-[#F55109] text-white hover:bg-[#e04a08]"
  } else {
    variantClasses = "bg-[#191919] text-white hover:bg-[#191919]/80"
  }

  const buttonClasses = `${baseClasses} ${disabledClasses} ${variantClasses} ${className}`

  // Choose arrow icon based on variant
  const arrowIcon = variant === 'orange' ? arrowRightWhite : arrowRight

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={buttonClasses}
    >
      <span className={`font-semibold tracking-wide ${variant === 'white' ? 'text-[#191919]' : 'text-white'}`}>
        {title}
      </span>
      
      <div className="flex items-center justify-center w-12 h-12 transition-transform hover:translate-x-1">
        <img
          src={arrowIcon}
          alt="Arrow right"
          className="w-8 h-8"
        />
      </div>
    </button>
  )
}

export default ServiceButton 